/**
 * Timeline Data - Storia di UNASCA
 * 
 * Questo file contiene i dati degli eventi storici di UNASCA
 * che vengono visualizzati nella pagina Timeline.
 * 
 * Per aggiungere nuovi eventi, aggiungi un nuovo oggetto all'array timelineEvents
 * seguendo la struttura TimelineEvent.
 */

export interface TimelineEvent {
  id: number;
  year: string;
  title: string;
  description: string;
  image?: string;
  icon: string;
  category: 'foundation' | 'milestone' | 'achievement' | 'expansion' | 'innovation';
  highlights?: string[]; // Punti salienti opzionali
  link?: string; // Link opzionale a un articolo di approfondimento
}

export const timelineEvents: TimelineEvent[] = [
  {
    id: 1,
    year: '1967',
    title: 'Fondazione di UNASCA',
    description: 'Il 25 febbraio 1967 nasce l\'Unione Nazionale Autoscuole e Studi di Consulenza Automobilistica, con l\'obiettivo di rappresentare e tutelare le imprese del settore.',
    image: '/images/timeline/logo-unasca (Telefono).png',
    icon: '🏛️',
    category: 'foundation'
  },
  {
    id: 2,
    year: '1970',
    title: 'Primo congresso a Roma',
    description: 'Si tiene il primo congresso nazionale UNASCA a Roma, momento fondamentale per la crescita dell\'associazione.',
    icon: '🏛️',
    category: 'milestone'
  },
  {
    id: 3,
    year: '1972',
    title: 'Primo indirizzario per le pratiche',
    description: 'Primo indirizzario per le pratiche di corrispondenza tra Agenzie in quanto le pratiche si dovevano eseguire presso gli uffici MCTC e PRA provinciali con il cambio targa da una provincia all\'altra a seguito di cambio provincia dell\'intestatario del veicolo.',
    icon: '📋',
    category: 'innovation'
  },
  {
    id: 4,
    year: '1977',
    title: 'Primo progetto di legge',
    description: 'Presentazione del primo progetto di legge per gli studi con la proposta di Legge n. 1090.',
    icon: '📜',
    category: 'milestone'
  },
  {
    id: 5,
    year: '1991',
    title: 'Contratto nazionale Lavoro',
    description: '21 marzo, L\'Unasca firma il contratto nazionale Lavoro per i dipendenti delle Agenzie e Autoscuole con le Organizzazioni sindacali.',
    icon: '✍️',
    category: 'achievement'
  },
  {
    id: 6,
    year: '1991',
    title: 'Legge 264/1991',
    description: 'L\'8 agosto viene promulgata la Legge 264/1991, che disciplina l\'attività degli studi di consulenza automobilistica, riconoscendo ufficialmente la professione e stabilendo le modalità operative.',
    image: '/images/timeline/legge-264-1992-1320x880.png',
    icon: '⚖️',
    category: 'milestone'
  },
  {
    id: 7,
    year: '1994',
    title: 'Il Progetto "F"',
    description: 'Il Progetto "F" (Immagine, Categoria, Legalità, Professionalità e FORMAZIONE) lanciato da Ottorino Pignoloni.',
    image: '/images/timeline/Ottorino_Pignoloni-700x492.jpg',
    icon: '🎯',
    category: 'innovation'
  },
  {
    id: 8,
    year: '1994',
    title: 'Creazione del Consorzio Sermetra',
    description: 'Il 21 giugno 1994, UNASCA fonda il Consorzio Sermetra con l\'obiettivo di creare una rete di agenzie di pratiche auto in Italia. Sermetra diventa la più grande rete di studi di consulenza e agenzie di pratiche auto nel paese, con oltre 1.200 sedi e milioni di pratiche gestite annualmente.',
    image: '/images/timeline/sermetra.jpeg',
    icon: '🏢',
    category: 'expansion'
  },
  {
    id: 9,
    year: '1994',
    title: 'PrenotaMotorizzazione',
    description: 'Inizio del partenariato pubblico-privato - Gli Studi di Consulenza Automobilistica, parte integrante di UNASCA, entrano in un modello di collaborazione con la Pubblica Amministrazione per la digitalizzazione dei servizi.',
    image: '/images/timeline/prenota.webp',
    icon: '💻',
    category: 'innovation'
  },
  {
    id: 10,
    year: '1998',
    title: 'Centro Studi Cesare Ferrari',
    description: 'Il 28 Marzo 1998, nasce il Centro studi Cesare Ferrari. E\' il coronamento di una visione che punta su una categoria formata e professionale. Viene dedicato a colui che più di altri ha spronato per l\'evoluzione operativa e culturale del nostro settore.',
    image: '/images/timeline/ferrari.jpeg',
    icon: '🎓',
    category: 'achievement'
  },
  {
    id: 11,
    year: '2000',
    title: 'Polo Telematico Sermetra',
    description: 'Grazie alla creazione del polo telematico, gli studi di consulenza hanno la possibilità di riscuotere il pagamento delle Tasse automobilistiche, fino a quel momento gestite da ACI e dalle sue delegazioni.',
    icon: '💳',
    category: 'innovation'
  },
  {
    id: 12,
    year: '2000',
    title: 'Approvazione del D.P.R. N. 358',
    description: 'Approvazione del D.P.R. N. 358 istitutivo dello STA (Sportello Telematico dell\'Automobilista).',
    icon: '📋',
    category: 'milestone'
  },
  {
    id: 13,
    year: '2001',
    title: 'Sperimentazione STA Cooperante',
    description: 'A giugno parte la sperimentazione dello STA Cooperante.',
    image: '/images/timeline/logo-STA-25.svg',
    icon: '🖥️',
    category: 'innovation'
  },
  {
    id: 14,
    year: '2002',
    title: 'Partenza definitiva STA Cooperante',
    description: 'Partenza definitiva dello STA Cooperante.',
    image: '/images/timeline/STC-sportello-telematico-cooperante.webp',
    icon: '⚡',
    category: 'innovation'
  },
  {
    id: 15,
    year: '2004',
    title: 'Riconoscimento ministeriale UNASCA',
    description: 'Il Ministero delle Infrastrutture e dei Trasporti riconosce UNASCA come associazione maggiormente rappresentativa per il settore delle autoscuole e studi di consulenza automobilistica (D.M. 9 febbraio 2004).',
    icon: '🏆',
    category: 'achievement'
  },
  {
    id: 16,
    year: '2004',
    title: 'Stampa targhe prova',
    description: 'Autorizzazione agli Studi per la stampa delle targhe prova.',
    image: '/images/timeline/pressa-targa-prova.webp',
    icon: '🔧',
    category: 'achievement'
  },
  {
    id: 17,
    year: '2006',
    title: 'Autentica di firma nello STA',
    description: 'La normativa prevede che l\'autentica della firma del venditore sugli atti di vendita dei veicoli usati possa avvenire anche presso lo Sportello Telematico dell\'Automobilista (STA) delle Unità Territoriali ACI (PRA) o degli Uffici Provinciali della Motorizzazione Civile (UMC).',
    image: '/images/timeline/autentica-di-firma-1320x880.png',
    icon: '✍️',
    category: 'milestone'
  },
  {
    id: 18,
    year: '2008',
    title: 'Corsi Autotrasporto',
    description: 'Riconoscimento del Centro Studi Cesare Ferrari quale Ente autorizzato per i corsi sull\'accesso alla professione dell\'Autotrasporto.',
    icon: '🚛',
    category: 'achievement'
  },
  {
    id: 19,
    year: '2012',
    title: 'Costituzione dell\'EBAS',
    description: 'Nasce l\'Ente Bilaterale Autoscuole e Studi (EBAS), organismo paritetico tra imprese e lavoratori, per la formazione continua e la qualificazione professionale.',
    icon: '🤝',
    category: 'achievement'
  },
  {
    id: 20,
    year: '2012',
    title: 'UNASCAbile',
    description: 'Nasce Unascabile, un progetto formativo che coinvolge gli Studi di consulenza Automobilistica e le Autoscuole, grazie ad un protocollo d\'intesa con la FISH (Federazione Italiana Superamento Handicap) in collaborazione con il Centro Studi Cesare Ferrari.',
    image: '/images/timeline/grazia_handbike.jpg',  
    icon: '♿',
    category: 'achievement'
  },
  {
    id: 21,
    year: '2013',
    title: 'UNASCA e Università di Macerata',
    description: 'Nel 2013 c\'è il primo passo che porterà alla collaborazione con l\'Università degli Studi di Macerata per la nascita dell\'indirizzo di Studi specifico "Consulente per i trasporti", con l\'obiettivo di definire figure altamente qualificate in specifici settori dell\'ordinamento giuridico.',
    image: '/images/timeline/universita-macerata-logo-orig.avif',
    icon: '🎓',
    category: 'expansion'
  },
  {
    id: 22,
    year: '2015',
    title: 'Introduzione del CDPD',
    description: 'Il 5 ottobre 2015 è stato emesso il primo Certificato Digitale di Proprietà (CDP), che ha sostituito del tutto il certificato cartaceo.',
    image: '/images/timeline/certificato_proprieta_digitale.jpg',
    icon: '📄',
    category: 'expansion'
  },  
  {
    id: 23,
    year: '2016',
    title: 'Rinnovo del CCNL',
    description: 'Il 13 dicembre 2016 viene sottoscritta l\'ipotesi di rinnovo del Contratto Collettivo Nazionale di Lavoro per i dipendenti di autoscuole e studi di consulenza automobilistica.',
    icon: '📝',
    category: 'achievement'
  },
  {
    id: 24,
    year: '2017',
    title: 'Aggiornamento professionale',
    description: 'UNASCA promuove corsi di formazione su nuove tecnologie per la sicurezza (ADAS di I e II generazione) e aggiornamenti per istruttori e insegnanti di guida. In Collaborazione con il Centro Studi Cesare Ferrari continua la formazione in presenza degli studi di consulenza, con l\'intento di mantenere aggiornati gli associati sulle varie normative vigenti.',
    image: '/images/timeline/sala.jpg',
    icon: '📚',
    category: 'innovation'
  },
  {
    id: 25,
    year: '2020',
    title: 'Formazione su mobilità elettrica',
    description: 'In collaborazione con Nissan, UNASCA avvia percorsi di formazione sulla mobilità elettrica per istruttori e consulenti.',
    image: '/images/timeline/nissan-e-unasca.webp',
    icon: '🔌',
    category: 'innovation'
  },
  {
    id: 26,
    year: '2020',
    title: 'STED Sportello Telematico del Diportista',
    description: 'Dal 1° Gennaio 2020 tutte le operazioni riguardanti imbarcazioni e navi da diporto verranno effettuate esclusivamente tramite uno STED - Sportello Telematico del Diportista.',
    image: '/images/timeline/sted-sportello-telematico-del-diportista-scaled.webp',
    icon: '🚤',
    category: 'innovation'
  },
  {
    id: 27,
    year: '2020',
    title: 'Attuazione D.L. 98/2017',
    description: '1° ottobre 2020 - Avvio del Documento Unico (DU) per alcune tipologie di pratiche (es. immatricolazioni e passaggi di proprietà di veicoli nuovi). Inizia gradualmente la sostituzione delle carte di circolazione e dei CDP/CDPD come deciso dal D.L. 98/2017',
    icon: '🔋',
    category: 'innovation'
  },
  {
    id: 28,
    year: '2021',
    title: 'Coordinamento Carta Europea',
    description: 'UNASCA assume il ruolo di coordinatore nazionale della Carta Europea della Sicurezza Stradale, consolidando la propria dimensione europea.',
    icon: '🇪🇺',
    category: 'expansion'
  },
  {
    id: 29,
    year: '2023',
    title: 'Sede UNASCA a Bruxelles',
    description: 'Il 2 maggio 2023 è stata inaugurata ufficialmente la sede Unasca di Bruxelles, operativa da circa un anno ma a cui mancava il suggello di una inaugurazione ufficiale. Avere una sede di rappresentanza nella "capitale europea" è un fatto di prestigio oltre che una base di lavoro importante per seguire gli sviluppi delle varie norme e direttive a livello comunitario.',
    icon: '🏢',
    category: 'expansion'
  },
  {
    id: 30,
    year: '2024',
    title: 'Protocollo d\'intesa con il Mininistro degli Interni',
    description: 'Il 24 settembre 2024 UNASCA firma, con i Ministeri competenti, un\'alleanza per promuovere la legalità e la trasparenza nei trasporti.',
    image: '/images/timeline/protocollo-di-intesa-con-ministero-interno-1320x880.png',
    icon: '🤝',
    category: 'achievement'
  },
  {
    id: 31,
    year: '2025',
    title: 'Rete Certificata UNASCA',
    description: 'Nasce la rete certificata Unasca, con attestato ufficiale rilasciato dal Poligrafico dello Stato. La rete si distingue per rigorosi standard di qualità, formazione continua e collaborazione tra agenzie aderenti per garantire al cittadino un’elevata professionalità e qualità degli Studi di Consulenza aderenti.',
    image: '/images/timeline/rete_certificata.png',
    icon: '💚',
    category: 'achievement',
    highlights: [
      'Riconoscimento ufficiale dal Poligrafico dello Stato',
      'Standard di qualità e formazione continua',
      'Collaborazione tra agenzie aderenti' 
    ],
    link: 'https://studi.unasca.it/rete-certificata'
  },
  {
    id: 32,
    year: '2025',
    title: 'REAT e Formazione obbligatoria',
    description: 'Un sogno di Unasca diventato realtà. Con il Decreto Direttoriale 20 giugno 2025, nasce per la prima volta il Registro delle Agenzie Telematiche (ReAT). Questo decreto rende obbligatoria la formazione in presenza e aggiornamento ogni 2 anni, per l\'accesso ai servizi del Ministero. Un punto essenziale per Unasca che si è sempre battuta per la formazione degli Studi di Consulenza come caposaldo della professionalità.',
    image: '/images/timeline/reat.jpg',
    icon: '📖',
    category: 'achievement'
  },
];

/**
 * Colori associati a ogni categoria di evento
 */
export const categoryColors = {
  foundation: 'from-purple-500 to-indigo-600',
  milestone: 'from-blue-500 to-cyan-600',
  achievement: 'from-yellow-500 to-orange-600',
  expansion: 'from-green-500 to-emerald-600',
  innovation: 'from-pink-500 to-rose-600'
};

/**
 * Etichette delle categorie in italiano
 */
export const categoryLabels = {
  foundation: 'Fondazione',
  milestone: 'Pietra Miliare',
  achievement: 'Traguardo',
  expansion: 'Espansione',
  innovation: 'Innovazione'
};

/**
 * Statistiche generali sulla storia di UNASCA
 */
export const timelineStats = {
  foundingYear: 1967,
  currentYear: new Date().getFullYear(),
  yearsOfHistory: new Date().getFullYear() - 1967,
  totalEvents: timelineEvents.length,
  totalMembers: 5000,
  regionalOffices: 20,
  europeanPartners: 15
};

/**
 * Funzione helper per ottenere eventi per categoria
 */
export const getEventsByCategory = (category: TimelineEvent['category']): TimelineEvent[] => {
  return timelineEvents.filter(event => event.category === category);
};

/**
 * Funzione helper per ottenere eventi per anno
 */
export const getEventsByYear = (year: string): TimelineEvent[] => {
  return timelineEvents.filter(event => event.year === year);
};

/**
 * Funzione helper per ottenere eventi in un range di anni
 */
export const getEventsByYearRange = (startYear: string, endYear: string): TimelineEvent[] => {
  const start = parseInt(startYear);
  const end = parseInt(endYear);
  return timelineEvents.filter(event => {
    const eventYear = parseInt(event.year);
    return eventYear >= start && eventYear <= end;
  });
};

/**
 * Funzione helper per ottenere l'evento più recente
 */
export const getLatestEvent = (): TimelineEvent => {
  return timelineEvents[timelineEvents.length - 1];
};

/**
 * Funzione helper per ottenere l'evento di fondazione
 */
export const getFoundationEvent = (): TimelineEvent => {
  return timelineEvents[0];
};

/**
 * Decadi rappresentate nella timeline
 */
export const decades = [
  { label: 'Anni \'60', start: '1960', end: '1969' },
  { label: 'Anni \'70', start: '1970', end: '1979' },
  { label: 'Anni \'80', start: '1980', end: '1989' },
  { label: 'Anni \'90', start: '1990', end: '1999' },
  { label: 'Anni 2000', start: '2000', end: '2009' },
  { label: 'Anni 2010', start: '2010', end: '2019' },
  { label: 'Anni 2020', start: '2020', end: '2029' }
];

export default timelineEvents;

